import {ChakraProvider} from '@chakra-ui/react';
import {FC, PropsWithChildren} from 'react';

import {config} from './config';

export const ThemeProvider: FC<PropsWithChildren> = ({children}) => {
  return (
    <ChakraProvider theme={config} resetCSS>
      {children}
    </ChakraProvider>
  );
};
